import { useNavigate, useLocation } from "react-router-dom"
import "../styles/Navbar.css"
import { useState } from "react"
import { supabase } from '../supabase';

import darkDocs from "../assets/documents_dark.png"
import lightDocs from "../assets/documents_light.png"

import darkAccount from "../assets/account_dark.png"
import lightAccount from "../assets/account_light.png"

import darkMedia from "../assets/media_dark.png"
import lightMedia from "../assets/media_light.png"

import darkExit from "../assets/exit_dark.png"
import lightExit from "../assets/exit_light.png"

import spineCommonsLogo from "../assets/spine commons image logo.png";

const Navbar = ({open, setopen, session}) => {

    const location = useLocation();
    const path = location.pathname; // path after base url (ex: /studies/2)
    const firstPath = path === '/' ? "documents" : path.split("/").filter(Boolean)[0]

    const [selected, setSelected] = useState("/" + firstPath)
    const [hovering, sethovering] = useState("")
    // const buttons = [["Media", "/media", darkMedia, lightMedia], ["Documents", "/documents", darkDocs, lightDocs], ["About", "/about", darkAbout, lightAbout]]
    const buttons = [["Media", "/media", darkMedia, lightMedia], ["Documents", "/documents", darkDocs, lightDocs]]
    buttons.push(session ? ["Account", "/account", darkAccount, lightAccount] : ["Login", "/auth", darkAccount, lightAccount])
    const nav = useNavigate();

    return (
        <div className={`navspacer ${open}`}>
            <div className={`mainNav1 ${open}`}>
                <div className='logospace'>
                    <div
                        className="navLogoLockup"
                        onClick={() => {
                            setSelected("/documents");
                            nav(`/documents?${new URLSearchParams({}).toString()}`, { replace: true });
                        }}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                setSelected("/documents");
                                nav(`/documents?${new URLSearchParams({}).toString()}`, { replace: true });
                            }
                        }}
                        aria-label="Go to Documents"
                    >
                            <img className="navLogoMark" src={spineCommonsLogo} alt="Spine Commons" />
                        <span className="navLogoText">Spine Commons</span>
                    </div>
                </div>
                <div className="sections">
                    <div className="open" onClick={() => {
                        setopen(!open)
                    }}>
                        <div className="lines">
                            <div className="one"></div>
                            <div className="two"></div>
                        </div>
                    </div>
                {
                    buttons.map((info) => ( // info = one array in the buttons array. info[0] is text, info[1] is a link
                        <div 
                        onClick={() => {
                            if (selected !== info[1]) {
                                setSelected(info[1])
                                nav(info[1] + "?" + new URLSearchParams({}).toString(), { replace: true })
                            }
                        }} 
                        onMouseEnter={() => sethovering(info[1])} 
                        onMouseLeave={() => sethovering("")} 
                        className={`pageselector ${selected === info[1]  ? "active" : (hovering === info[1] ? "hovering" : "")}`}
                        >
                            <div className="selectorimg">
                                <img src={info[2] ? info[2] : null} className={`actimg`} alt="" />
                                <img
                                    src={info[3] ? info[3] : null}
                                    className={`actimg ${hovering === info[1] || selected === info[1] ? "visimg" : "invimg"}`}
                                    alt=""
                                />
                            </div>
                            <h1 className={`selectortext ${selected === info[1]  ? "active" : (hovering === info[1] ? "hovering" : "")}`}>{info[0]}</h1>
                        </div>
                    ))
                }
                {session &&
                <div 
                        onClick={async () => {
  const { error } = await supabase.auth.signOut();
  if (error) {
    console.error('Error logging out:', error.message);
  } else {
    // Clear any local session state and redirect
    nav("/", { replace: true });
    window.location.reload();
  }
}}
                        onMouseEnter={() => sethovering("logout")} 
                        onMouseLeave={() => sethovering("")} 
                        className={`pageselector ${hovering === "logout" ? "hovering" : ""}`}
                        >
                            <div className="selectorimg">
                                <img src={darkExit} className={`actimg`} alt="" />
                                <img
                                    src={lightExit}
                                    className={`actimg ${hovering === "logout" || selected === "logout" ? "visimg" : "invimg"}`}
                                    alt=""
                                />
                            </div>
                            <h1 className={`selectortext ${hovering === "logout" ? "hovering" : ""}`}>Logout</h1>
                    </div>
                    }
                    
                
                </div>
            </div>
        </div>
        
    )   
}

export default Navbar;